import { getCache } from 'core/cache';
import { useModals } from 'core/notifications';

export default (id) => {
  const { getModel, removeModal, setModel } = useModals();
  const modelsCache = getCache('notificationsModalsById');
  const legacyModels = modelsCache.data;
  const hasLegacyModel = id in legacyModels;

  const getModelShim = () => (hasLegacyModel ? legacyModels[id] : getModel(id));

  const removeModalShim = ({ payload, type = 'CLOSE' } = {}) => {
    if (!hasLegacyModel) return removeModal({ payload, type });

    const { modals } = getCache('notifications').data;

    return modals[modals.length - 1].commitAction({ payload, type });
  };

  const setModelShim = (_, data) =>
    hasLegacyModel ? modelsCache.set({ [id]: data }, { setType: 'extend' }) : setModel(id, data);

  return {
    getModel: getModelShim,
    removeModal: removeModalShim,
    setModel: setModelShim,
  };
};
